export var Name = 'social-media-library';
export var SocialMediaLibraryAnalytics = Name;
export var SMLAnalyticsEventType;

(function (SMLAnalyticsEventType) {
  SMLAnalyticsEventType["ContentFilter"] = "contentFilter";
  SMLAnalyticsEventType["ItemClick"] = "itemClick";
  SMLAnalyticsEventType["ShareClick"] = "shareClick";
  SMLAnalyticsEventType["DownloadClick"] = "downloadClick";
})(SMLAnalyticsEventType || (SMLAnalyticsEventType = {}));